import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import logger from "redux-logger";
import {favoriteReducer, characterReducer}  from "./reducers";

const reducers = combineReducers({
  favoriteReducer,
  characterReducer
});

const store = createStore(reducers, applyMiddleware(thunk, logger));

export default store;
